// TODO: Some monitoring and testing to see how frequently this will fail
export var CLIENT_TIMEOUT = 3000;
export var targetClientOptions = {
    client: "bca",
    organizationId: "E5F2C8A15481C0E20A4C98BC@AdobeOrg",
    timeout: CLIENT_TIMEOUT,
    serverDomain: "bcaoxforddev.112.2o7.net",
    decisioningMethod: "on-device"
};
